@if (ngControl.control; as control) {
<div [class]="'datepicker-v2 preset-' + preset">
  @if (showDateField) {
  <mat-form-field class="date-field">
    <mat-label>{{ label }}{{ isFieldRequired(control) }}</mat-label>
    <input
      matInput
      [matDatepicker]="dp"
      [formControl]="dateControl"
      [min]="min"
      [max]="max"
      [matDatepickerFilter]="dateFilter"
      readonly
      [attr.test-id]="testId"
      [ngClass]="{ prefilled: disabled }"
      class="tw-cursor-pointer"
      (click)="dp.open()"
      (focus)="onDateInputFocus()"
    />
    <ui-svg-icon
      [name]="fontIcon"
      [class.calendar-icon__disabled]="dateControl.disabled"
      class="tw-cursor-pointer"
      matSuffix
      (click)="dp.open()"
    ></ui-svg-icon>
    @if (showWarningIcon) {
    <ui-svg-icon
      [name]="iconNames.AlertWarningFilled"
      class="tw-cursor-pointer tw-text-bosch-yellow-80 tw-pl-2"
      [matTooltip]="warningTooltip"
      matSuffix
    ></ui-svg-icon>
    }

    <mat-datepicker #dp [startAt]="startAt" (opened)="onPickerOpened()" (closed)="onPickerClosed()">
      @if (showTimeFields) {
      <mat-datepicker-actions>
        <div class="v2-popup-footer">
          <div class="v2-time-row">
            <div class="v2-time-stepper">
              <button type="button" class="v2-stepper-btn" (click)="incrementHour()">▲</button>
              <input
                type="text"
                inputmode="numeric"
                class="v2-time-input"
                [value]="hourDisplay"
                (input)="onHourInputChange($event)"
                (blur)="onHourBlur($event)"
                maxlength="2"
              />
              <button type="button" class="v2-stepper-btn" (click)="decrementHour()">▼</button>
            </div>

            @if (!isHourOnlyMode) {
            <div class="v2-time-stepper">
              <button type="button" class="v2-stepper-btn" (click)="incrementMinute()">▲</button>
              <input
                type="text"
                inputmode="numeric"
                class="v2-time-input"
                [value]="minuteDisplay"
                (input)="onMinuteInputChange($event)"
                (blur)="onMinuteBlur($event)"
                maxlength="2"
              />
              <button type="button" class="v2-stepper-btn" (click)="decrementMinute()">▼</button>
            </div>
            }
          </div>

          <div class="v2-action-row">
            <button mat-button type="button" matDatepickerCancel>
              {{ 'common.button.cancel' | translate }}
            </button>
            <button mat-raised-button type="button" color="primary" matDatepickerApply (click)="onPickerApply()">
              {{ 'common.button.set' | translate }}
            </button>
          </div>
        </div>
      </mat-datepicker-actions>
      }
    </mat-datepicker>

    @if (timezoneText) {
    <mat-hint class="timezone-info-text">{{ timezoneText }}</mat-hint>
    } @if (control?.invalid && control.value) {
    <mat-error>
      {{ errorMessage || ('common.validation.error.required' | translate) }}
    </mat-error>
    } @if (control?.invalid && !control.value) {
    <mat-error>
      {{ 'common.validation.error.required' | translate }}
    </mat-error>
    }
  </mat-form-field>
  } @if (pickerType === 'timer') {
  <mat-form-field class="date-field">
    <mat-label>{{ label }}{{ isFieldRequired(control) }}</mat-label>
    <input
      matInput
      [value]="timerDisplay"
      placeholder="--:--"
      readonly
      [attr.test-id]="testId"
      [ngClass]="{ prefilled: disabled }"
      class="tw-cursor-pointer"
      [matMenuTriggerFor]="timerMenu"
      #timerMenuTrigger="matMenuTrigger"
      (menuOpened)="onTimerMenuOpened()"
    />
    <button
      type="button"
      matSuffix
      [disabled]="ngControl.control?.disabled"
      class="timer-icon-btn"
      (click)="timerMenuTrigger.openMenu()"
    >
      <ui-svg-icon [name]="fontIcon" [class.calendar-icon__disabled]="ngControl.control?.disabled"></ui-svg-icon>
    </button>
    @if (showWarningIcon) {
    <ui-svg-icon
      [name]="iconNames.AlertWarningFilled"
      class="tw-cursor-pointer tw-text-bosch-yellow-80 tw-pl-2"
      [matTooltip]="warningTooltip"
      matSuffix
    ></ui-svg-icon>
    } @if (timezoneText) {
    <mat-hint class="timezone-info-text">{{ timezoneText }}</mat-hint>
    } @if (control?.invalid && control.value) {
    <mat-error>
      {{ errorMessage || ('common.validation.error.required' | translate) }}
    </mat-error>
    } @if (control?.invalid && !control.value) {
    <mat-error>
      {{ 'common.validation.error.required' | translate }}
    </mat-error>
    }
  </mat-form-field>

  <mat-menu #timerMenu="matMenu" panelClass="v2-timer-menu">
    <div class="v2-timer-content" (click)="$event.stopPropagation()">
      <div class="v2-time-row">
        <div class="v2-time-stepper">
          <button type="button" class="v2-stepper-btn" (click)="incrementHour()">▲</button>
          <input
            type="text"
            inputmode="numeric"
            class="v2-time-input"
            [value]="hourDisplay"
            (input)="onHourInputChange($event)"
            (blur)="onHourBlur($event)"
            maxlength="2"
          />
          <button type="button" class="v2-stepper-btn" (click)="decrementHour()">▼</button>
        </div>
        @if (!isHourOnlyMode) {
        <div class="v2-time-stepper">
          <button type="button" class="v2-stepper-btn" (click)="incrementMinute()">▲</button>
          <input
            type="text"
            inputmode="numeric"
            class="v2-time-input"
            [value]="minuteDisplay"
            (input)="onMinuteInputChange($event)"
            (blur)="onMinuteBlur($event)"
            maxlength="2"
          />
          <button type="button" class="v2-stepper-btn" (click)="decrementMinute()">▼</button>
        </div>
        }
      </div>
      <div class="v2-action-row">
        <button mat-button type="button" (click)="onTimerMenuCancel()">
          {{ 'common.button.cancel' | translate }}
        </button>
        <button mat-raised-button type="button" color="primary" (click)="onTimerMenuApply()">
          {{ 'common.button.set' | translate }}
        </button>
      </div>
    </div>
  </mat-menu>
  }
</div>
}
